import { createContext, useState, useEffect, useCallback } from "react";
import { useInterval } from "@mantine/hooks";
import OfflineStatusViewer from "Components/displayOfflineStatus/offlineStatus";

function needsPolling() {
	const unsupportedUserAgentsPattern = /Windows.*Firefox|Linux.*Chrome/;
	if (typeof navigator !== "undefined" && unsupportedUserAgentsPattern.test(navigator.userAgent)) {
		return true;
	}
	return false;
}

export const NetworkStatusContext = createContext(false);

const NetworkStatusProvider = ({ children }) => {

	const [online, setOnline] = useState(navigator.onLine);

	const ping = useCallback(({ url, timeout }) => {
		return new Promise((resolve, reject) => {
			const isOnline = () => resolve();
			const isOffline = () => reject();

			const xhr = new XMLHttpRequest();

			xhr.onerror = isOffline;
			xhr.ontimeout = isOffline;
			xhr.onreadystatechange = () => {
				if (xhr.readyState === xhr.HEADERS_RECEIVED) {
					if (xhr.status) {
						isOnline();
					} else {
						isOffline();
					}
				}
			};

			xhr.open("HEAD", url);
			xhr.timeout = timeout;
			xhr.send();
		});
	}, []);

	useEffect(() => {
		window.addEventListener("online", setOnline(true));
		window.addEventListener("offline", setOnline(false));

		return () => {
			window.removeEventListener("online", setOnline(true));
			window.removeEventListener("offline", setOnline(false));
		};
	}, []);

	const interval = useInterval(() => {
		ping({ url: "https://ipv4.icanhazip.com/", timeout: 2000 })
			.then(() => setOnline(true))
			.catch(() => setOnline(false));
	}, 2500);

	useEffect(() => {
		if (!online) {
			console.log("Lost network connection");
			interval.start();
		}
		if (online && interval.active) {
			console.log("Regained network connection");
			interval.stop();
		}
	}, [online, interval]);

	return (
		<NetworkStatusContext.Provider value={online}>
			<OfflineStatusViewer online={online} />
			{children || null}
		</NetworkStatusContext.Provider>
	);
};

export default NetworkStatusProvider;
